module.exports = __webpack_public_path__ + "static/media/Item_Weapon_Mini14_C.5f2f6ed3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_Mini14_C.png
// module id = 231
// module chunks = 0